// This stub component exists for the mdma test, so the webpack alias of /hf gets appeased on imports.  This can be removed when the test is retired
export const CondensedHeader = () => null;
export default CondensedHeader;
